import { Button, ButtonGroups } from "@nocios/presentation-kit";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PanelNumbersEffects from "src/Component/PanelNumbersEffects";
import Config from "src/Constants/Config";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";

const PageId = 1;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const [step, setStep] = useState(0);
  const baseIcons = `${Config.BASE_URL}/images/icons/`;
  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_1 = `${baseImageUrl}animation_0.png`;

  const rightSideComponentBaseStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    transition: "opacity .6s ease-in-out",
    height: "auto",
    width: "var(--width-1197)",
  };

  useEffect(() => {
    let timeoutId: any;
    if (currentPage === PageId) {
      if (step === 0) timeoutId = setTimeout(() => setStep(step + 1), 200);
    } else setStep(0);

    return () => {
      setStep(0);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const stepsTime = [200, 100, 400];

  useEffect(() => {
    let timeoutId: any;
    if (step > 0 && step <= stepsTime.length) timeoutId = setTimeout(() => setStep(step + 1), stepsTime[step - 1]);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const buttons = [
    {
      label: "SEE OUR PLATFORM",
      type: "back",
      onClick: () => setCurrentPage(NextPageId),
      startIcon: {
        icon: `${baseIcons}product.png`,
        style: { width: "var(--width-28)", height: "auto", paddingRight: "var(--width-6)" },
      },
      style: {
        borderColor: "transparent",
        color: "#000",
        width: "var(--width-237)",
        borderRadius: "4px",
        background: "var(--Linear, linear-gradient(90deg, #C4E6FF 0%, #E2C3FF 100%))",
        boxShadow: "0px 5.702px 61.296px 0px rgba(255, 255, 255, 0.30)",
      },
    },
    {
      label: "WATCH OUR DEMO VIDEO",
      type: "next",
      onClick: () => setCurrentPage(BackPageId),
      style: { width: "var(--width-237)" },
    },
  ];

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    gradient: "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%)",
    styleBody: {
      marginTop: "var(--width-155)",
    },
    title: "Accelerating the Smart Home\nRevolution on a Global Scale",
    styleTitle: {
      color: "#FFF",
      fontFamily: "Tungsten",
      fontSize: "var(--width-64)",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "var(--height-71)",
      textTransform: "uppercase",
    },
    description:
      "The <b>Infosys In-home Connectivity Platform</b> reduces<br/>complexity & cost and empowers service providers to<br/>harness this growth, offering scalable, modular, and<br/>efficient solutions tailored for the modern world.",
    styleDescription: {
      color: "#FFF",
      fontFamily: "Myriad Pro",
      fontSize: "var(--width-24)",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "140%",
      marginTop: "var(--width-18)",
    },
    leftAfterDescription: (
      <ButtonGroups style={{ flexDirection: "column", gap: "var(--width-16)", marginTop: "var(--width-72)" }}>
        {buttons.map((button, index) => (
          <Button key={index} {...button} />
        ))}
      </ButtonGroups>
    ),
    rightSideComponent: (
      <>
        <img src={rightSideImage_1} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 1 ? 1 : 0 }} />
        <PanelNumbersEffects pageId={PageId} startAnimation={step > 2} />
      </>
    ),
  };
};

export default DATA;
